'use client';

import React, { createContext, useContext, useState, useCallback } from 'react';

interface EffectsContextValue {
  isLoaded: boolean;
  setLoaded: (v: boolean) => void;
  isMenuOpen: boolean;
  setMenuOpen: (v: boolean) => void;
  toggleMenu: () => void;
}

const EffectsContext = createContext<EffectsContextValue | null>(null);

export function EffectsProvider({ children }: { children: React.ReactNode }) {
  const [isLoaded, setLoaded] = useState(true);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const toggleMenu = useCallback(() => setMenuOpen((prev) => !prev), []);

  return (
    <EffectsContext.Provider data-component-id="src/contexts/EffectsContext.tsx:21:4" data-component-path="src/contexts/EffectsContext.tsx" data-component-line="21" data-component-end-line="25" data-component-file="EffectsContext.tsx" data-component-name="EffectsContext.Provider" data-component-content="%7B%22elementName%22%3A%22EffectsContext.Provider%22%7D"
      value={{ isLoaded, setLoaded, isMenuOpen, setMenuOpen, toggleMenu }}
    >
      {children}
    </EffectsContext.Provider>
  );
}

export function useEffects() {
  const ctx = useContext(EffectsContext);
  if (!ctx) throw new Error('useEffects must be used within EffectsProvider');
  return ctx;
}
